import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { proofLibraryItems } from '../mockData';

const ProofLibrarySection = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  
  const handleVideoClick = (video) => {
    setSelectedVideo(video);
  };
  
  const closeModal = () => {
    setSelectedVideo(null);
  };
  
  return (
    <section className="py-20 px-4 bg-[#040c14] relative overflow-hidden">
      {/* Abstract background with ethereal glow */}
      <div className="absolute inset-0 opacity-15 pointer-events-none">
        <div className="abstract-blob animate-float" style={{ 
          top: '20%', 
          right: '5%', 
          width: '500px', 
          height: '500px', 
          background: 'radial-gradient(circle, rgba(255, 101, 0, 0.3), transparent 70%)',
          filter: 'blur(90px)'
        }}></div>
        <div className="abstract-blob animate-float-delayed" style={{ 
          bottom: '10%', 
          left: '10%', 
          width: '450px', 
          height: '450px', 
          background: 'radial-gradient(circle, rgba(255, 180, 100, 0.25), transparent 70%)',
          filter: 'blur(85px)'
        }}></div>
        <div className="abstract-blob animate-float-slow" style={{ 
          top: '50%', 
          left: '50%', 
          width: '400px', 
          height: '400px', 
          background: 'radial-gradient(circle, rgba(255, 140, 50, 0.2), transparent 70%)',
          filter: 'blur(95px)',
          transform: 'translate(-50%, -50%)'
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 text-center">
          Proof <span className="text-[#FF6500]">Gallery</span>
        </h2>
        <p className="text-xl text-[#aaa] text-center mb-12 max-w-3xl mx-auto">
          Cinematic proof-of-concept work showcasing augmented storytelling.
        </p>
        
        {/* Gallery Grid - 4 items per row */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {proofLibraryItems.map((item) => (
            <div 
              key={item.id}
              onClick={() => handleVideoClick(item)}
              className="group cursor-pointer bg-[#0a1525] rounded-lg overflow-hidden hover:transform hover:-translate-y-2 transition-all duration-300 border border-[#152840] hover:border-[#FF6500]/50 hover:shadow-xl hover:shadow-[#FF6500]/10"
            >
              <div className="relative aspect-video overflow-hidden bg-black">
                <img 
                  src={item.thumbnail} 
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Play button overlay */}
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                  <div className="w-16 h-16 bg-[#FF6500] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-[#FF6500]/30">
                    <Play className="w-8 h-8 text-black ml-1" />
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-white group-hover:text-[#FF6500] transition-colors duration-300">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Video Modal */}
      {selectedVideo && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4 animate-fadeIn"
          onClick={closeModal}
        >
          <div 
            className="relative w-full max-w-6xl animate-scaleIn"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 p-2 text-white hover:text-[#FF6500] transition-colors duration-300"
              aria-label="Close video"
            >
              <X className="w-8 h-8" />
            </button>
            
            <div className="aspect-video w-full bg-black rounded-lg overflow-hidden shadow-2xl shadow-[#FF6500]/20">
              {selectedVideo.type === 'mp4' ? (
                <video
                  src={selectedVideo.videoUrl}
                  title={selectedVideo.title}
                  className="w-full h-full"
                  controls
                  autoPlay
                />
              ) : selectedVideo.type === 'youtube' ? (
                <iframe
                  src={`${selectedVideo.videoUrl}?autoplay=1`}
                  title={selectedVideo.title}
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <iframe
                  src={selectedVideo.videoUrl}
                  title={selectedVideo.title}
                  className="w-full h-full"
                  frameBorder="0"
                  allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
            
            <div className="mt-6 text-center">
              <h3 className="text-2xl font-semibold text-white mb-2">{selectedVideo.title}</h3>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProofLibrarySection;